import 'alpinejs'
import IMask from 'imask';
import * as Ladda from 'ladda';

window.axios = require('axios');
window.$ = window.jQuery = require('jquery');
window.Swal = require('sweetalert2');
window.toastr = require("toastr");
window.Dropzone = require("dropzone");
window.IMask = IMask;
window.moment = require('moment');
window.Ladda = Ladda;
require('simplelightbox');

// CoreUI
require('@coreui/coreui-pro');
window.Utils = require("@coreui/utils");

import 'bootstrap-datepicker';
require("bootstrap-datepicker/js/locales/bootstrap-datepicker.sk");

// Boilerplate
require('./plugins');
